module.exports = __webpack_public_path__ + "img/news.e2edc4e2.svg";